module.exports = __webpack_public_path__ + "static/mobile-img-9c85f765660eb95030541c43706cfa90.png";